import React from "react";

//material ui
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

const useStyles = (theme, isMobile) => ({
  error: {
    marginTop: "48px",
    width: "100%",
    padding: "20px 0px",
    background: "rgba(255, 6, 46, 0.03)",
    outline: "solid 1px #ff062e",
    borderRadius: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  about: {
    marginTop: "48px",
    width: "100%",
    padding: "20px 0px",
    background: "rgba(185, 185, 185, 0.041)",
    borderRadius: "56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  typography: {
    error: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      textAlign: isMobile ? "center" : "left",
      marginLeft: isMobile ? "0px" : "32px",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "20px" : "22px",
      color: theme.palette.red.main,
      minHeight: isMobile ? "110px" : { md: "66px", lg: "66px", xl: "auto" },
      mx: isMobile ? "16px" : "32px",
    },
    about: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      minHeight: isMobile ? "110px" : "auto",
      mx: isMobile ? "16px" : "32px",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "20px" : "22px",
      textAlign: isMobile ? "center" : "left",
    },
  },
});

const ErrorMsg = ({ error }) => {
  const isMobile = useMediaQuery("(max-width:899px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  if (error) {
    return (
      <Box sx={classes.error}>
        <Typography sx={classes.typography.error}>{error}</Typography>
      </Box>
    );
  } else {
    return (
      <Box sx={classes.about}>
        <Typography sx={classes.typography.about}>
          <span>
            <b>Con esta información crearemos tu cuenta de Pledu,</b> nuestra
            plataforma educativa.
          </span>
        </Typography>
      </Box>
    );
  }
};

export default ErrorMsg;
